"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var CountBarStyles_1 = require("../../style/CountBarStyles");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var StyleFunctions_1 = require("../../style/StyleFunctions");
var CountBar_1 = require("../widgets/CountBar");
var fadeInAnimation = StyleFunctions_1.keyframes({
    '0%': { opacity: 0 },
    '100%': { opacity: 1 }
});
var BarContainer = LayoutComponents_1.divWithStyle('BarContainer', {
    animationName: fadeInAnimation,
    animationDuration: '250ms',
    animationTimingFunction: 'ease-in',
});
function LineageFilteredBar(props) {
    var unfilteredCount = props.unfilteredCount;
    var filteredCount = props.filteredCount;
    if (unfilteredCount != null && filteredCount != null) {
        var barTitle = Localize_1.Messages.XofN({
            countX: Localize_1.Formatters.formatCount(filteredCount),
            countN: Localize_1.Formatters.formatCount(unfilteredCount)
        });
        return (React.createElement(BarContainer, { title: barTitle },
            React.createElement(CountBar_1.CountBar, { maxValue: props.unfilteredCount, currentValue: props.filteredCount, maxWidth: CountBarStyles_1.lineageBarMaxWidth, height: CountBarStyles_1.lineageBarHeight, colorPaletteName: 'lineage', shouldAnimateBarWidth: true })));
    }
    else {
        return React.createElement("div", { style: { height: CountBarStyles_1.lineageBarHeight } });
    }
}
exports.LineageFilteredBar = LineageFilteredBar;
//# sourceMappingURL=LineageFilteredBar.js.map